<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <custom-popup
        v-model="dialog"
        :cons="cons"
        max-width="640"
        reloadable
        @reload="reloadCats"
      >
        <template v-slot:helpinfo>
          <help-info
            :element-name="`${serviceName}-${componentName}-select-category`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            label="انتخاب دسته‌بندی"
          />
        </template>
        <v-row class="pa-2" no-gutters>
          <v-col class="sticky-top white" cols="12" style="top: 68px">
            <v-card-actions>
              <div class="rowinfo">
                <v-text-field
                  v-model="search"
                  class="rounded-lg contnetinfo"
                  clearable
                  dense
                  label="جستجو"
                  outlined
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-search`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="جستجو"
                />
              </div>
            </v-card-actions>
          </v-col>

          <v-col class="pa-2" cols="12">
            <v-expand-transition>
              <div
                v-if="!!tempSelected && !!tempSelected.length"
                class="d-flex align-center"
                style="gap: 4px"
              >
                <v-chip v-for="(item, i) in tempSelected" :key="i" small>{{
                  item.name
                }}</v-chip>
              </div>
            </v-expand-transition>
          </v-col>

          <v-col
            v-if="loading && (!categories || !categories.length)"
            cols="12"
          >
            <v-card
              class="d-flex align-center justify-center flex-column text-center"
              flat
              height="200"
            >
              <v-progress-circular
                class="mx-auto mb-2"
                indeterminate
                size="45"
                width="5"
              />
              درحال دریافت دسته‌بندی‌ها...
            </v-card>
          </v-col>

          <template v-else-if="!!categories && !!categories.length">
            <v-col
              v-for="(category, i) in computedCategories"
              :key="i"
              class="pa-2"
              cols="12"
              lg="3"
              md="4"
              sm="6"
            >
              <v-card
                :class="{
                  'blue lighten-4': computedSelectedIds.includes(category.id),
                }"
                class="rounded-lg pa-3 text-center d-flex flex-column align-center justify-center"
                outlined
                style="aspect-ratio: 9/16"
              >
                <v-avatar class="border" color="light-blue lighten-3" size="64">
                  <v-icon>mdi-account</v-icon>
                </v-avatar>

                <v-card-title
                  class="text-center justify-center px-2"
                  style="word-break: break-word"
                >
                  {{ category.name }}
                </v-card-title>

                <v-spacer />
                <v-card-actions class="justify-center">
                  <div class="rowinfo">
                    <v-btn
                      :color="
                        computedSelectedIds.includes(category.id)
                          ? 'red lighten-2'
                          : 'light-blue lighten-3'
                      "
                      depressed
                      rounded
                      @click="select(category)"
                      class="contentinfo"
                    >
                      {{
                        computedSelectedIds.includes(category.id)
                          ? "حذف"
                          : "انتخاب"
                      }}
                    </v-btn>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-computedSelectedIds`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="حذف /انتخاب"
                    />
                  </div>
                </v-card-actions>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </custom-popup>
    </template>
  </help-info-wrapper>
</template>

<script>
import { mapState } from "vuex";
import InsuranceContent from "@/utilities/InsuranceContent";

export default {
  name: "insuranceCategoryPicker",

  props: {
    value: Boolean,
    items: [Array, Object],
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "insuranceCategory-picker",
      categories: [],
      cons: {
        title: "انتخاب دسته‌بندی",
        buttons: [{ type: "submit", handler: this.saveTempsSelected }],
      },
      tempSelected: [],
      search: "",
      loading: false,
      insuranceObject: new InsuranceContent(this.createQrID),
    };
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    ...mapState("local", ["qr_id"]),
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedCategories() {
      if (this.search?.length >= 2) {
        return this.categories.filter((item) =>
          item.name.includes(this.search)
        );
      }
      return this.categories;
    },
    computedSelectedIds() {
      return this.tempSelected.map((item) => item.id);
    },
  },

  watch: {
    dialog(val) {
      !!val && !this.categories?.length && this.getInsurances();
    },
  },

  methods: {
    getInsurances() {
      this.loading = true;

      // this.$api.get('/v1/testQr/insurances')
      this.insuranceObject
        .list()
        .then(({ data }) => (this.categories = data.data))
        .catch(({ response }) => {
          this.$toast.error("خطا در دریافت اطلاعات دسته‌بندی‌ها!");
          console.log("failed to get all categories: ", response);
        })
        .finally(() => (this.loading = false));
    },
    select(item) {
      if (this.computedSelectedIds.includes(item.id)) {
        let index = this.tempSelected.indexOf(item);
        this.tempSelected.splice(index, 1);
      } else this.tempSelected.push(item);
    },
    reloadCats() {
      this.tempSelected = [];
      this.getInsurances();
    },
    saveTempsSelected() {
      this.loading = true;

      let obj = {
        qr_id: this.createQrID ?? this.qr_id,
        category_id: this.tempSelected.map((item) => item.id),
      };

      this.insuranceObject
        .storeQrInsurance(obj)
        .then(({ data }) => {
          this.tempSelected = [];
          this.$emit(
            "update:items",
            data.data.map((item) => item.category)
          );
        })
        .catch(({ response }) =>
          console.log("failed to save qr insurances: ", response)
        )
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
